import { ChevronRight, Home } from "lucide-react";

interface BreadcrumbsProps {
  items: Array<{ label: string; href?: string }>;
  variant?: "dark" | "light";
}

export default function Breadcrumbs({
  items,
  variant = "dark",
}: BreadcrumbsProps) {
  const isDark = variant === "dark";
  const textColor = isDark ? "text-white" : "text-black";
  const iconColor = isDark ? "white" : "black";

  return (
    <nav className="flex items-center gap-2 py-3">
      {/* Home Icon */}
      <a
        href="/"
        className={`flex items-center gap-2 ${textColor} hover:text-brand-orange transition-colors font-kepler text-text-sm-custom`}
      >
        <Home size={18} color={iconColor} />
        <span>Home</span>
      </a>

      {/* Breadcrumb Items */}
      {items.map((item, index) => (
        <div key={index} className="flex items-center gap-2">
          <ChevronRight size={18} color={iconColor} className="flex-shrink-0" />
          {item.href ? (
            <a
              href={item.href}
              className={`${textColor} hover:text-brand-orange transition-colors font-kepler text-text-sm-custom`}
            >
              {item.label}
            </a>
          ) : (
            <span className={`${textColor} font-kepler text-text-sm-custom`}>
              {item.label}
            </span>
          )}
        </div>
      ))}
    </nav>
  );
}
